import React from 'react';
import * as ContextMenu from '@radix-ui/react-context-menu';
import { FiEdit, FiTrash } from 'react-icons/fi';

const _ContextMenu = ({ children }) => {
  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger>{children}</ContextMenu.Trigger>
      <ContextMenu.Portal>
        <ContextMenu.Content
          className="min-w-[220px] bg-white rounded-md overflow-hidden p-[5px] shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)]"
          sideOffset={5}
          align="end"
        >
          <ContextMenu.Item className="group text-[13px] leading-none text-violet11 rounded-[3px] flex items-center space-x-2 h-[25px] px-[5px] relative pl-[25px] select-none outline-none data-[disabled]:text-mauve8 data-[disabled]:pointer-events-none data-[highlighted]:bg-violet9 data-[highlighted]:text-violet1">
            <FiEdit /> <span>Edit Node Inputs</span>
          </ContextMenu.Item>
          <ContextMenu.Item className="group text-[13px] leading-none text-violet11 rounded-[3px] flex items-center space-x-2 h-[25px] px-[5px] relative pl-[25px] select-none outline-none data-[disabled]:text-mauve8 data-[disabled]:pointer-events-none data-[highlighted]:bg-violet9 data-[highlighted]:text-violet1">
            <FiTrash /> <span>Delete Node</span>
          </ContextMenu.Item>
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  );
};

export default _ContextMenu;
